var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailSendEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_1597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0368 18.6312L13.656 22.2528C13.8809 22.4772 14.1592 22.6406 14.4648 22.7278C14.7703 22.8149 15.093 22.8228 15.4025 22.7508C15.7119 22.6788 15.9979 22.5292 16.2336 22.3161C16.4693 22.103 16.6468 21.8334 16.7496 21.5328L22.704 3.65758C22.8135 3.32866 22.8294 2.97572 22.7497 2.63831C22.67 2.30089 22.4979 1.99233 22.2528 1.74718C22.0076 1.50203 21.6991 1.32997 21.3616 1.25028C21.0242 1.17059 20.6713 1.18642 20.3424 1.29598L2.47677 7.25038C2.17567 7.35257 1.90561 7.52986 1.69212 7.76549C1.47862 8.00113 1.32875 8.28732 1.25667 8.59701C1.1846 8.9067 1.1927 9.22965 1.2802 9.53534C1.36771 9.84103 1.53174 10.1193 1.75677 10.344L5.99997 14.4V21.6L10.0368 18.6312Z",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14.4L15.9 7.0656",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_1597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSendEmail);
export default __webpack_public_path__ + "static/media/mail-send-email.587736a5e66525150ff7a0d717dc8c2b.svg";
export { ForwardRef as ReactComponent };